import { Card, Spinner } from 'react-bootstrap';
import React, { useCallback, useMemo } from 'react';
import { RequestFileImage } from '../../common/RequestFile/RequestFileImage';
import { urlConst } from '../../../consts';
import { formatRequestUser } from '../../../util';
import './request-one-file.css';

export function RequestOneFile(props) {
    const { file, request, readOnly, getting, onDeleteClick, onBindUserClick } = props;

    const [fileUrl, fileName, linkHost] = useMemo(() => {
        let ref;
        let name = file.filename;
        let host;
        if (file.fileVariant === 'VIDEO_LINK') {
            ref = file.link;
            if (!name) name = file.link;
            try {
                host = new URL(ref).host;
                if (host && host.startsWith('www.')) host = host.substr(4);
            } catch (e) {
                console.log(`error of parse url '${ref}': ${e.message}`);
            }
        } else {
            ref = `${urlConst.API_GET_REQUEST_FILE}?file=${file.id}`;
        }
        return [ref, name, host];
    }, [file]);
    const isGlobalFile = file.fileType.isGlobal;
    const requestUserStr = useMemo(() => {
        if (file.fileType.isGlobal || !file.userId) {
            return '';
        }
        const requestUser = request.users.find((u) => u.role === 'participant' && u.user.id === file.userId);
        if (!requestUser) {
            return '';
        }
        return formatRequestUser(requestUser);
    }, [file, request]);
    const needUser = !isGlobalFile && !requestUserStr;
    const fileBgClass = needUser ? 'danger' : 'light';

    const handleCloseClick = useCallback(
        (event) => {
            onDeleteClick(file);
            event.stopPropagation();
            event.preventDefault();
        },
        [file, onDeleteClick]
    );

    const handleBindUserClick = useCallback(
        (event) => {
            onBindUserClick(file);
            event.stopPropagation();
        },
        [file, onBindUserClick]
    );

    return (
        <Card border={fileBgClass} className="mb-2" style={{ minWidth: '14rem', maxWidth: '14rem' }}>
            <Card.Header
                className="d-flex btn btn-light"
                as="a"
                href={fileUrl}
                target="_blank"
                rel="noopener noreferrer"
            >
                <div>
                    <RequestFileImage requestFile={file} />
                </div>
                <div className="flex-grow-1 d-flex flex-column">
                    <small
                        className={'flex-grow-1 text-break px-1 ' + (linkHost ? 'two-lines-dots' : 'three-lines-dots')}
                        title={fileName}
                    >
                        {fileName}
                    </small>
                    {linkHost && <small className="text-muted">{linkHost}</small>}
                </div>
                {!readOnly && (
                    <div className="align-self-start">
                        <button
                            type="button"
                            className="close"
                            title="Удалить"
                            disabled={getting}
                            onClick={handleCloseClick}
                        >
                            {getting ? (
                                <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                            ) : (
                                <span>&times;</span>
                            )}
                        </button>
                    </div>
                )}
            </Card.Header>
            {!isGlobalFile && (
                <Card.Body className="btn btn-light p-1" onClick={handleBindUserClick}>
                    {needUser ? (
                        <small className="text-danger">Кликни, чтобы привязать участника</small>
                    ) : (
                        <small>{requestUserStr}</small>
                    )}
                </Card.Body>
            )}
        </Card>
    );
}
